import { useCreateThread, useThreads } from '@liveblocks/react'
import { useMemo } from 'react'

import type { RiskQuestionnaireThreadCardProps } from '@/pages/control/risk-questionnaire-thread-card/risk-questionnaire-thread-card'
import { ThreadCardContent } from '@/pages/control/risk-questionnaire-thread-card/thread-card-content'

import { isExternalCommentThread } from '@/components/shared/comment/utils'

type ThreadCardWithLiveCommentsProps = RiskQuestionnaireThreadCardProps

export const ThreadCardWithLiveComments = (props: ThreadCardWithLiveCommentsProps) => {
  const createThread = useCreateThread()
  const threadsResult = useThreads({ query: { metadata: { controlId: props.controlStatusId } } })

  const liveThreads = useMemo(
    () => threadsResult.threads?.filter(isExternalCommentThread),
    [threadsResult.threads],
  )

  return (
    <ThreadCardContent
      {...props}
      liveThreads={liveThreads}
      liveThreadsPending={threadsResult.isLoading}
      onCreateThread={createThread}
    />
  )
}
